/** Client WebSocket de la messagerie : reconnexion auto + abonnement aux événements. */
export function openChatSocket() {
  const listeners = new Map();
  let ws = null, closed = false, retry = 0;

  function emit(type, data) { (listeners.get(type) || []).forEach((f) => f(data)); }

  function connect() {
    const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
    ws = new WebSocket(`${proto}//${location.host}/ws/chat`);
    ws.onopen = () => { retry = 0; emit('open'); };
    ws.onmessage = (e) => { let m; try { m = JSON.parse(e.data); } catch { return; } emit(m.t, m); };
    ws.onclose = () => { if (closed) return; setTimeout(connect, Math.min(800 * 2 ** retry++, 8000)); };
    ws.onerror = () => { try { ws.close(); } catch {} };
  }
  connect();

  return {
    on(type, fn) {
      if (!listeners.has(type)) listeners.set(type, new Set());
      listeners.get(type).add(fn);
      return () => listeners.get(type)?.delete(fn);
    },
    send(obj) { try { if (ws && ws.readyState === 1) ws.send(JSON.stringify(obj)); } catch {} },
    close() { closed = true; try { ws && ws.close(); } catch {} },
  };
}
